import {Button, Group, Stack, Text} from '@mantine/core'
import {Link} from '@tanstack/react-router'

import type {Customer} from './types'

type CustomerSummaryProps = {
    customer: Customer
    onEdit?: () => void
    editHref?: string
    onChangeCustomer?: () => void
}

export function CustomerSummary({
    customer,
    onEdit,
    editHref,
    onChangeCustomer,
}: CustomerSummaryProps) {
    const showActions =
        onEdit !== undefined || editHref !== undefined || onChangeCustomer !== undefined

    return (
        <Stack gap="xs">
            <Text fw={600}>{customer.name}</Text>
            {customer.contactName && <Text size="sm">Contact: {customer.contactName}</Text>}
            {customer.phone && <Text size="sm">Phone: {customer.phone}</Text>}
            {customer.email && <Text size="sm">Email: {customer.email}</Text>}
            {showActions && (
                <Group gap="sm">
                    {editHref ? (
                        <Button
                            component={Link}
                            to={editHref}
                            type="button"
                            variant="light"
                            size="xs"
                        >
                            Edit customer details
                        </Button>
                    ) : null}
                    {onEdit && !editHref ? (
                        <Button type="button" variant="light" size="xs" onClick={onEdit}>
                            Edit customer details
                        </Button>
                    ) : null}
                    {onChangeCustomer && (
                        <Button type="button" variant="subtle" size="xs" onClick={onChangeCustomer}>
                            Change customer
                        </Button>
                    )}
                </Group>
            )}
        </Stack>
    )
}
